export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", seq: "cat-shoes" },
  { name: "Hoodies & Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", seq: "cat-hoodies" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", seq: "cat-tshirts" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", seq: "cat-jackets" },
  { name: "Pants & Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", seq: "cat-pants" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", seq: "cat-headwear" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", seq: "cat-sets" },
  { name: "Underwear & Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", seq: "cat-underwear" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", seq: "cat-jersey" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", seq: "cat-accessories" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", seq: "cat-bags" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", seq: "cat-belts" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", seq: "cat-perfumes" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", seq: "cat-other" },
];

export const testimonials = [
  {
    name: "Marcus J.",
    role: "Fashion Enthusiast, NYC",
    title: "Best spreadsheet shopping tool I've found",
    body: "GTBuy Sheet completely changed how I shop for streetwear. Being able to compare prices across three platforms in one view saves me hours every week. The curated deals are always on point.",
  },
  {
    name: "Sophie L.",
    role: "Stylist, London",
    title: "A game-changer for my styling business",
    body: "I source pieces for clients weekly and this spreadsheet system is incredible. Cross-referencing GTBuy, Kakobuy, and Superbuy prices has never been easier. Highly recommend for anyone who shops smart.",
  },
  {
    name: "David K.",
    role: "Sneaker Collector, LA",
    title: "Found deals I never would have caught",
    body: "The side-by-side comparison reveals price gaps you'd never notice browsing individually. I've saved at least 40% on my last three hauls just by using the spreadsheet before buying.",
  },
  {
    name: "Emma R.",
    role: "Budget Shopper, Toronto",
    title: "Simple, effective, and actually useful",
    body: "No fluff, no complicated setup — just a clean spreadsheet that tells me exactly where to get the best price. It's become my go-to before any online clothing purchase.",
  },
  {
    name: "James W.",
    role: "Reseller, Miami",
    title: "Essential tool for margin calculations",
    body: "When you're flipping items, every dollar counts. GTBuy Sheet lets me instantly see which platform gives me the best buy-in price. It's basically my profit calculator now.",
  },
  {
    name: "Olivia T.",
    role: "College Student, Chicago",
    title: "Made me a smarter shopper overnight",
    body: "I used to just buy from one site without comparing. Now I check the spreadsheet first and it's crazy how much I save. The category filters make finding exactly what I want so fast.",
  },
];